import React, {useCallback, useEffect, useRef, useState} from 'react';
import './Partners.css';
import {Link} from 'react-router-dom';


import curacareakademie from '../assets/images/curacareacademy.webp';
import guidodilg from '../assets/images/guidodilg.webp';
import ceydacare from '../assets/images/ceydacare.webp';
import emek from '../assets/images/emek.webp';
import sanivia from '../assets/images/sanivia.webp';
import mmpflegeberatung from '../assets/images/MMPflegeberatung.webp';
import pflegezulauf from '../assets/images/pflegezulauf.webp';


const PARTNERS=[
  {src:curacareakademie, alt:'Cura Care Akademie', to:'/leistungen/pflegeakademie', internal:true},
  {src:guidodilg, alt:'Praxis Dr. Guido Dilg', href:'https://www.dr-dilg.de/'},
  {src:ceydacare, alt:'Ceyda Care', href:'https://www.instagram.com/ceyda_care/'},
  {src:emek, alt:'EMEK', href:'https://emek-pflegedienst.de/'},
  {src:sanivia, alt:'Sanivia', href:'https://sanivia.de/'},
  {src:mmpflegeberatung, alt:'MM Pflegeberatung', href:'https://www.mm-pflegeberatung.de/'},
  {src:pflegezulauf, alt:'Pflegezulauf', href:'https://pflegezulauf.de/'},
];


const PartnersSection=()=>{
  const [idx,setIdx]=useState(0);
  const [isSingle,setIsSingle]=useState(false);
  const timerRef=useRef(null);
  const hasMultiple=PARTNERS.length>1;

  const mod=(n,m)=>((n%m)+m)%m;
  const left=mod(idx-1, PARTNERS.length);
  const center=idx;
  const right=mod(idx+1, PARTNERS.length);

  const next=useCallback(()=>setIdx((i)=>mod(i+1, PARTNERS.length)), []);
  const prev=useCallback(()=>setIdx((i)=>mod(i-1, PARTNERS.length)), []);

  useEffect(()=>{
    if(!hasMultiple) return;
    const start=()=>{
      stop();
      timerRef.current=setInterval(next, 3200);
    };
    const stop=()=>{
      if(timerRef.current){ clearInterval(timerRef.current); timerRef.current=null; }
    };
    const onVis=()=>document.hidden?stop():start();

    start();
    document.addEventListener('visibilitychange', onVis);
    return()=>{
      stop();
      document.removeEventListener('visibilitychange', onVis);
    };
  },[hasMultiple, next]);

  const pause=()=>{ if(timerRef.current){ clearInterval(timerRef.current); timerRef.current=null; } };
  const resume=()=>{ if(hasMultiple && !timerRef.current){ timerRef.current=setInterval(next, 3200); } };

  // Switch to single-card mode for narrow screens (prevents overflow)
  useEffect(()=>{
    if(typeof window==='undefined' || !window.matchMedia) return;
    const mq=window.matchMedia('(max-width: 640px)');
    const update=(e)=>setIsSingle(e.matches);
    update(mq);
    if(mq.addEventListener){
      mq.addEventListener('change', update);
      return()=>mq.removeEventListener('change', update);
    }
    mq.addListener(update);
    return()=>mq.removeListener(update);
  },[]);

  const triplet=[PARTNERS[left], PARTNERS[center], PARTNERS[right]];
  const visibleCards=isSingle?[PARTNERS[center]]:triplet;

  return(
    <section className="partners-strip" id="partner">
      <div className="strip-inner" onMouseEnter={pause} onMouseLeave={resume}>
        <h2 className="strip-title">Hand in Hand mit</h2>

        <div className="strip-row">
          {hasMultiple && (
            <button
              className="strip-arrow strip-arrow--left"
              aria-label="Vorheriger Partner"
              onClick={prev}
            >‹</button>
          )}

          <div className="strip-view">
            <div className={`strip-view__track ${isSingle?'is-single':''}`}>
              {visibleCards.map((p,i)=>{
                const card=(
                  <div className={`strip-card ${(!isSingle && i===1)?'is-center':''}`}>
                    <img src={p.src} alt={p.alt} className="partner-logo" loading="lazy" />
                  </div>
                );

                return p.internal ? (
                  <Link
                    key={`${p.alt}-${i}`}
                    to={p.to}
                    className="strip-card-link"
                    aria-label={p.alt}
                  >
                    {card}
                  </Link>
                ):(
                  <a
                    key={`${p.alt}-${i}`}
                    href={p.href}
                    target="_blank"
                    rel="noreferrer"
                    className="strip-card-link"
                    aria-label={p.alt}
                  >
                    {card}
                  </a>
                );
              })}

            </div>
          </div>

          {hasMultiple && (
            <button
              className="strip-arrow strip-arrow--right"
              aria-label="Nächster Partner"
              onClick={next}
            >›</button>
          )}
        </div>

        {hasMultiple && (
          <div className="strip-dots" role="tablist" aria-label="Partner-Navigation">
            {PARTNERS.map((_,i)=>(
              <button
                key={i}
                className={`dot ${i===idx?'active':''}`}
                aria-label={`Partner ${i+1}`}
                aria-selected={i===idx}
                role="tab"
                onClick={()=>setIdx(i)}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default PartnersSection;
